(function () {
  var STORAGE_KEY = 'wudy_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wudy:wishlist:change', { detail: { items: items } }));
  }

  function isSaved(productId) {
    var id = String(productId);
    return read().some(function (item) {
      return String(item.id) === id;
    });
  }

  function toggle(product) {
    var id = String(product.id);
    var items = read();
    var idx = items.findIndex(function (item) {
      return String(item.id) === id;
    });

    if (idx >= 0) {
      items.splice(idx, 1);
      write(items);
      return false;
    }

    items.unshift(product);
    write(items);
    return true;
  }

  function syncButton(btn) {
    var active = isSaved(btn.getAttribute('data-product-id'));
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-wudy-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function bind(scope) {
    scope = scope || document;

    scope.querySelectorAll('[data-wudy-wishlist]').forEach(function (btn) {
      if (btn.dataset.wudyWishlistInit === 'true') return;
      btn.dataset.wudyWishlistInit = 'true';

      btn.addEventListener('click', function () {
        var product = {
          id: btn.getAttribute('data-product-id'),
          handle: btn.getAttribute('data-product-handle'),
          title: btn.getAttribute('data-product-title'),
          url: btn.getAttribute('data-product-url'),
          image: btn.getAttribute('data-product-image'),
          price: btn.getAttribute('data-product-price') || '',
          variantId: btn.getAttribute('data-variant-id') || ''
        };

        if (!product.id) return;

        toggle(product);
        syncButton(btn);
        updateCount();
      });

      syncButton(btn);
    });

    updateCount();
  }

  function initAmbience(page) {
    var layer = page.querySelector('[data-wudy-wishlist-ambience]');
    if (!layer || layer.dataset.wudyAmbienceInit === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    layer.dataset.wudyAmbienceInit = 'true';

    var targetX = 0;
    var targetY = 0;
    var currentX = 0;
    var currentY = 0;
    var scrollY = 0;
    var rafId = 0;

    function tick() {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      layer.style.transform =
        'translate3d(' + currentX.toFixed(2) + 'px, ' + (currentY + scrollY).toFixed(2) + 'px, 0)';
      rafId = requestAnimationFrame(tick);
    }

    page.addEventListener('mousemove', function (e) {
      var rect = page.getBoundingClientRect();
      var nx = (e.clientX - rect.left) / rect.width - 0.5;
      var ny = (e.clientY - rect.top) / rect.height - 0.5;
      targetX = nx * 28;
      targetY = ny * 18;
    }, { passive: true });

    page.addEventListener('mouseleave', function () {
      targetX = 0;
      targetY = 0;
    });

    window.addEventListener('scroll', function () {
      scrollY = window.scrollY * 0.04;
    }, { passive: true });

    rafId = requestAnimationFrame(tick);

    page.addEventListener('shopify:section:unload', function () {
      if (rafId) cancelAnimationFrame(rafId);
    });
  }

  function renderPage(root) {
    if (!root) return;

    var listEl = root.querySelector('[data-wudy-wishlist-list]');
    var emptyEl = root.querySelector('[data-wudy-wishlist-empty]');
    if (!listEl) return;

    var items = read();
    listEl.innerHTML = '';

    if (!items.length) {
      if (emptyEl) emptyEl.hidden = false;
      listEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    listEl.hidden = false;

    items.forEach(function (item) {
      var card = document.createElement('a');
      card.className = 'wudy-wishlist-card';
      card.href = item.url || ('/products/' + item.handle);
      card.innerHTML =
        (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '<div class="wudy-wishlist-card__body">' +
          '<p class="wudy-wishlist-card__title">' + (item.title || '') + '</p>' +
          (item.price ? '<p class="wudy-wishlist-card__price">' + item.price + '</p>' : '') +
        '</div>';

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'wudy-wishlist-card__remove';
      removeBtn.setAttribute('aria-label', 'Remove from wishlist');
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(item);
        renderPage(root);
        bind(document);
      });

      card.appendChild(removeBtn);
      listEl.appendChild(card);
    });
  }

  function ensureMobileMenuStyles() {
    if (document.getElementById('wudy-mobile-menu-fallback-style')) return;
    var style = document.createElement('style');
    style.id = 'wudy-mobile-menu-fallback-style';
    style.textContent =
      '.wudy-mobile-menu{position:fixed;inset:0;z-index:990;background:rgba(10,10,10,.5);display:flex;justify-content:flex-start;}' +
      '.wudy-mobile-menu[hidden]{display:none;}' +
      '.wudy-mobile-menu__panel{width:min(90vw,360px);height:100%;background:#faf7f2;color:#1a1a1a;padding:14px 18px 20px;display:flex;flex-direction:column;gap:20px;box-shadow:8px 0 24px rgba(0,0,0,.18);}' +
      '.wudy-mobile-menu__head{display:flex;align-items:center;justify-content:space-between;gap:12px;}' +
      '.wudy-mobile-menu__title{font:500 11px/1.2 Inter,system-ui,sans-serif;letter-spacing:.18em;text-transform:uppercase;}' +
      '.wudy-mobile-menu__close{width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;border:0;background:none;color:#1a1a1a;padding:0;cursor:pointer;}' +
      '.wudy-mobile-menu__nav{display:flex;flex-direction:column;gap:2px;}' +
      '.wudy-mobile-menu__link{display:flex;align-items:center;min-height:48px;border-bottom:1px solid rgba(0,0,0,.08);color:#1a1a1a;text-decoration:none;font:400 14px/1.2 Inter,system-ui,sans-serif;letter-spacing:.04em;padding:0 4px;}' +
      '.wudy-mobile-menu__link--journal{font-family:\"Inter\",ui-sans-serif,system-ui,sans-serif;font-style:normal;font-weight:500;font-size:22px;letter-spacing:-0.02em;}' +
      'html.wudy-menu-open,html.wudy-menu-open body{overflow:hidden;}';
    document.head.appendChild(style);
  }

  function ensureMobileMenuMarkup() {
    var existing = document.querySelector('[data-mobile-menu]');
    if (existing) return existing;

    var wrapper = document.createElement('div');
    wrapper.id = 'wudy-mobile-menu';
    wrapper.className = 'wudy-mobile-menu';
    wrapper.setAttribute('data-mobile-menu', '');
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-modal', 'true');
    wrapper.setAttribute('aria-label', 'Mobile menu');
    wrapper.hidden = true;
    wrapper.innerHTML =
      '<div class="wudy-mobile-menu__panel" role="document">' +
        '<div class="wudy-mobile-menu__head">' +
          '<span class="wudy-mobile-menu__title">Menu</span>' +
          '<button type="button" class="wudy-mobile-menu__close" aria-label="Close menu" data-mobile-menu-close>&times;</button>' +
        '</div>' +
        '<nav class="wudy-mobile-menu__nav" aria-label="Primary mobile">' +
          '<a href="/collections/pro-cookware" class="wudy-mobile-menu__link">Pro Cookware</a>' +
          '<a href="/collections/master-collection-knives" class="wudy-mobile-menu__link">Master Series (Knives)</a>' +
          '<a href="/collections/kitchen-essentials" class="wudy-mobile-menu__link">Kitchen Essentials</a>' +
          '<a href="/collections/tea-coffee" class="wudy-mobile-menu__link">Tea &amp; Coffee</a>' +
          '<a href="/collections/summer-26" class="wudy-mobile-menu__link">Summer 26</a>' +
          '<a href="/pages/journal" class="wudy-mobile-menu__link wudy-mobile-menu__link--journal">Journal</a>' +
          '<a href="/pages/faq" class="wudy-mobile-menu__link">FAQ</a>' +
          '<a href="/pages/track-order" class="wudy-mobile-menu__link">Track Order</a>' +
          '<a href="/pages/contact" class="wudy-mobile-menu__link">Contact</a>' +
          '<a href="/pages/reviews" class="wudy-mobile-menu__link">Leave a note</a>' +
          '<a href="/pages/our-vision" class="wudy-mobile-menu__link">Vision</a>' +
        '</nav>' +
      '</div>';

    document.body.appendChild(wrapper);
    return wrapper;
  }

  function initMobileMenu() {
    if (window.__wudyMenuBoundByHeader) return;
    var toggle = document.querySelector('.wudy-mobile-toggle, [data-mobile-menu-toggle], button[aria-label="Menu"]');
    if (!toggle || toggle.dataset.wudyMobileMenuInit === 'true') return;

    ensureMobileMenuStyles();
    var drawer = ensureMobileMenuMarkup();
    if (!drawer) return;

    var menuScrollY = 0;

    var close = function () {
      drawer.hidden = true;
      document.documentElement.classList.remove('wudy-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.removeProperty('--wudy-scrollbar-width');
      window.scrollTo(0, menuScrollY);
      toggle.setAttribute('aria-expanded', 'false');
    };
    var open = function () {
      menuScrollY = window.scrollY || window.pageYOffset || 0;
      var sbw = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      document.documentElement.style.setProperty('--wudy-scrollbar-width', sbw + 'px');
      document.body.style.top = '-' + menuScrollY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      drawer.hidden = false;
      document.documentElement.classList.add('wudy-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    toggle.dataset.wudyMobileMenuInit = 'true';
    toggle.setAttribute('aria-controls', drawer.id || 'wudy-mobile-menu');
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.hidden) open();
      else close();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
    drawer.querySelectorAll('[data-mobile-menu-close], .wudy-mobile-menu__link').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  window.WudyWishlist = {
    read: read,
    toggle: toggle,
    isSaved: isSaved,
    bind: bind,
    renderPage: renderPage
  };

  document.addEventListener('DOMContentLoaded', function () {
    bind();
    document.querySelectorAll('[data-wudy-wishlist-page]').forEach(function (page) {
      renderPage(page);
      initAmbience(page);
    });
    initMobileMenu();
  });

  document.addEventListener('wudy:wishlist:change', function () {
    document.querySelectorAll('[data-wudy-wishlist-page]').forEach(renderPage);
    bind(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
    event.target.querySelectorAll('[data-wudy-wishlist-page]').forEach(function (page) {
      renderPage(page);
      initAmbience(page);
    });
    initMobileMenu();
  });
})();
